import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { Footer } from './Footer';

/**
 * Persistent app frame: sidebar + top bar wrap the route outlet.
 *
 * We deliberately do NOT use <AnimatePresence mode="wait"> here. With exit
 * animations on the routed outlet, navigating back could leave the old page
 * mid-exit while the new (lazy) page suspended — stranding a blank/black frame.
 * A keyed mount-only fade-in gives the same polish with zero blank-frame risk.
 */
export function AppShell() {
  const location = useLocation();
  return (
    <div className="app-bg flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        <main className="min-h-0 flex-1 overflow-y-auto">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, ease: [0.2, 0.8, 0.2, 1] }}
            className="mx-auto w-full max-w-[1440px] space-y-6 px-6 py-6"
          >
            <Outlet />
          </motion.div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
